import axios from 'axios';

import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  REGISTER_SET_LOADING,
  // GET_SUCCESS,
  // GET_ERRORS
} from '../actions/types';

function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}
// registerUser
export const registerUser = (formData) => async (dispatch) => {
  dispatch({
    type: REGISTER_SET_LOADING,
  });

  const config = {
    method: 'post',
    url: `/api/users/register/`,
    data: formData,
    headers: {
      'Content-Type': 'application/json',
      "csrftoken": getCookie('csrftoken'),
      "X-CSRFTOKEN": getCookie('csrftoken'),
    },

  };
// axios.defaults.xsrfCookieName = 'csrftoken'
// axios.defaults.xsrfHeaderName = "X-CSRFTOKEN"
  try {
    const response = await axios(config);

    dispatch({
      type: REGISTER_SUCCESS,
      payload: response.data
    });

    // dispatch(
    //   loadUser()
    // )
  } catch (err) {
    const errors = {
      msg: err.response.data,
      status: err.response.status,
    };
    // dispatch({
    //   type: GET_ERRORS,
    //   payload: errors
    // })

    dispatch({
      type: REGISTER_FAIL,
      payload: errors.msg
    });
  }
};
